import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource, Tooltip2} from '@api'
import {Spinner} from '@blueprintjs/core'
import {useStores, useVipLocalStore, VipLocalStore} from '@modules'
import {StoresInstance} from '@stores'
import * as css from './FlexLayoutSavingIndicator.css'

/// region Components

interface MyProps {
  className?: string
}

export const FlexLayoutSavingIndicator = observer<MyProps>(function FlexLayoutSavingIndicator({className, ...props}) {
  const {reports: {currentReport}} = useStores()
  if (!currentReport?.saving) return null

  return (
      <div title='Saving Report' className={css.root}>
        <Spinner size={12} />
      </div>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/flexComponents/flexLayout-widgets/FlexLayoutSavingIndicator.tsx